export const WBS_LENGTH = 24;
export const INTERNAL_ORDER_LENGTH = 50;
export const EXTRA_INTERNAL_ORDER_LENGTH = 300;

